import React from 'react';

import { StandardOrganisationPredictionBuilderContext } from '../context/standard-organisation-prediction-builder-context';
import { usePredictionsInfoContext } from '../../detail/context/predictions-info-context';
import { ConsolidatedOrganisationPredictionBuilderContext } from '../context/consolidated-organisation-prediction-builder-context';
import { StandardOrganisationPredictionDrawer } from './standard-organisation/standard-organisation-prediction-drawer';
import { ConsolidatedOrganisationPredictionDrawer } from './consolidated-organisation/consolidated-organisation-prediction-drawer';

interface Props {
  urlPredictionId?: string;
  urlPredictionType?: string;
  isQuickCopy?: boolean;
  onClose: () => void;
}

export const PredictionBuilderContainer = ({ urlPredictionId, urlPredictionType, isQuickCopy, onClose }: Props) => {
  const { isConsolidation } = usePredictionsInfoContext();

  if (isConsolidation) {
    return (
      <ConsolidatedOrganisationPredictionBuilderContext
        urlPredictionId={urlPredictionId}
        urlPredictionType={urlPredictionType}
        isQuickCopy={isQuickCopy}
        onClose={onClose}
      >
        <ConsolidatedOrganisationPredictionDrawer isOpen={true} onClose={onClose} />
      </ConsolidatedOrganisationPredictionBuilderContext>
    );
  }

  return (
    <StandardOrganisationPredictionBuilderContext
      urlPredictionId={urlPredictionId}
      urlPredictionType={urlPredictionType}
      isQuickCopy={isQuickCopy}
      onClose={onClose}
    >
      <StandardOrganisationPredictionDrawer isOpen={true} onClose={onClose} />
    </StandardOrganisationPredictionBuilderContext>
  );
};
